import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getReportsData } from "../../../modules/reports/action";
import "../../../style";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import Loader from "../../Loader";
import ReportsFormList from "./ReportsFormList";
import ReportsGenerateTable from "./ReportsGenerateTable";

class ReportsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      isreportGenerated: false,
      headerRows: {
        loadDate: "Load Date",
        ticketNumber: "Ticket Number",
        originTypeId: "Origin",
        commodityResponseDTO: "Commodity",
        destination: "Destination",
        truckline: "Truckline",
        quantity: "Quantity"
      },
      order: "desc",
      orderBy: "id",
      fetchingSubFarmId: false
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.ReportList &&
      nextProps.ReportList !== this.props.ReportList
    ) {
      this.setState({ fetchingComplete: true });
    }
  }

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  reportGenerated = queryString => {
    this.setState({
      isreportGenerated: true,
      fetchingComplete: false
    });
    this.props.actions.getReportsData(queryString);
  };

  deleteRow = id => {
    this.props.actions.deleteTicket(id);
  };
  render() {
    const { fetchingComplete, order, orderBy, isreportGenerated } = this.state;
    const { ReportList, ErrorMessage } = this.props;

    return (
        <div className="ticket-body">
          { isSuperAdmin() && this.props.MainFarmId==="ALL_MAIN_FARM" ? (
            <AllMainFarmSelectedDialog />
          ) :
          (
          <div>
            <ReportsFormList reportGenerated={this.reportGenerated} />
            <div>
              {isreportGenerated ? (
                fetchingComplete ? (
                  ErrorMessage && ErrorMessage.message ? (
                    <div className="ErrorMessage">{ErrorMessage.message}</div>
                  ) : (
                    <ReportsGenerateTable rowData={ReportList} />
                  )
                ) : (
                  <Loader />
                )
              ) : (
                ""
              )}
            </div>
          </div>
          )
          }
        </div>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    TicketList: state.ticketReducer.TicketList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    ReportList: state.ReportsReducer.ReportList,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getReportsData
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportsView);



// WEBPACK FOOTER //
// ./src/components/private/Reports/ReportsView.js